<companyid-content-wrapper classNames="pt-40px pb-120px tab:px-5 mob:px-5 w-full">
    <div class="flex gap-x-130px w-full">
        <div class="flex flex-col gap-y-45px max-w-[670px] tab:max-w-full mob:max-w-full">
            @for (item of contentItems(); let i = $index; track item.title) {
                <div class="flex-col flex gap-y-15px text-dark" [id]="i" #itemsBlock>
                    <span class="text-h6-semi-bold">{{ item.title }}</span>
                    @for (content of item.sections; track content.subtitle) {
                        @if (content.subtitle) {
                            <span class="text-small-medium">{{ content.subtitle }} </span>
                        }
                        @if (content.paragraphTitle) {
                            <span class="text-small-regular text-primary-text-color">
                                {{ content.paragraphTitle }}</span
                            >
                        }
                        @if (content.paragraph) {
                            @for (paragraph of content.paragraph; track paragraph.title) {
                                <span class="text-small-regular text-primary-text-color"
                                    >• {{ paragraph.title }}
                                    @if (paragraph.link) {
                                        <a
                                            [href]="paragraph.link"
                                            target="_blank"
                                            class="underline"
                                            >{{ paragraph.linkTitle }}</a
                                        >
                                    }
                                </span>
                            }
                        }
                        @if (content.text) {
                            <span class="text-small-regular text-primary-text-color">
                                {{ content.text }}</span
                            >
                        }
                    }
                </div>
            }
        </div>
        <div class="w-[370px] relative mob:hidden tab:hidden">
            <div class="flex flex-col sticky top-40px">
                @for (item of contentItems(); let i = $index; track item.title) {
                    <span
                        (click)="anchorScroll(i, itemsBlock(), scrollIntoViewPosition)"
                        (keydown)="handleKeydown($event, i)"
                        tabindex="0"
                        [class]="
                            [
                                'px-25px cursor-pointer py-2.5 border-l-2',
                                activeId() === i
                                    ? 'bg-gray-2 border-primary-color text-dark-2 text-small-medium'
                                    : 'text-small-regular text-primary-text-color border-stroke',
                            ] | joinClassNames
                        ">
                        {{ item.title }}</span
                    >
                }
            </div>
        </div>
    </div>
</companyid-content-wrapper>
